<template>
  <section
    v-if="data.wistiaVideoEmbed && data.wistiaVideoEmbed.length"
    :class="{ 'container mx-auto': true }"
  >
    <div :class="{ 'relative aspect-video': true }">
      <div
        v-if="data.wistiaVideoEmbed && data.wistiaVideoEmbed[0]"
        :class="{
          'h-full w-full': true,
          'popover=true popoverContent=thumbnail': true,
          'popoverAnimateThumbnail=true wistia_embed_initialized': true,
          ['wistia_embed wistia_async_' + data.wistiaVideoEmbed[0].hashed_id]: true,
        }"
      ></div>

      <template v-if="data.wistiaVideoMetadata?.duration">
        <div
          :class="{
            'absolute bottom-0 z-10 grid min-w-[17%] bg-[#f5f6f9] p-14px text-8px text-www-color-accent-blue-dark max-md:right-0 md:left-0 lg:px-30px lg:py-5 lg:text-12px': true,
          }"
        >
          <!-- TODO Get Value From Sanity -->
          <span
            :class="{
              'font-medium md:w-1': true,
            }"
            >VIDEO DURATION:</span
          >
          <span>{{ formatDuration(data.wistiaVideoMetadata.duration) }}</span>
        </div>
      </template>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { QueryVideoResult } from '~/sanity/types';

interface Props {
  data: NonNullable<QueryVideoResult>;
}

defineProps<Props>();

useHead({
  script: [
    { key: 'wistia-script', src: 'https://fast.wistia.com/assets/external/E-v1.js', async: true },
    {
      key: 'wistia-transcript-script',
      src: 'https://fast.wistia.com/assets/external/transcript.js',
      async: true,
    },
  ],
});
</script>
